import React from 'react';

import Icon from '../../components/shared/icon/Icon';
import FormText from '../../components/forms/formText/FormText';

import validEmail from '../../services/validEmail'

interface IOwnProps {
    disabled: boolean;
    onChange: (event?: React.ChangeEvent<HTMLInputElement>) => void;
    alternateEmails: string[];
    modelErrors?: any;
}

interface IOwnState {
    alternateEmails: { [key: string]: string };
    formRefs: Array<React.RefObject<FormText>>;
    disableAdd: boolean;
}

class AlternateEmails extends React.Component<IOwnProps, IOwnState> {
    constructor(props: IOwnProps) {
        super(props);

        this.state = {
            alternateEmails: {},
            formRefs: [],
            disableAdd: false
        };
    }

    public componentDidMount() {
        this.setAlternateEmails(this.props.alternateEmails);
    }

    public componentDidUpdate(prevProps: IOwnProps) {
        if (prevProps.alternateEmails.length === 0 && prevProps.alternateEmails !== this.props.alternateEmails) {
            this.setAlternateEmails(this.props.alternateEmails);
        }
    }

    public render() {
        return <React.Fragment>
            {Object.keys(this.state.alternateEmails).map((ae, i) =>
                <FormText
                    key={i}
                    name={`email-${i}`}
                    label="Ekstra e-mail"
                    initialValue={this.state.alternateEmails[ae]}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    validator={validEmail}
                    invalid={this.props.modelErrors && this.props.modelErrors[`AlternateEmails[${i}]`]}
                    notice={this.props.modelErrors && this.props.modelErrors[`AlternateEmails[${i}]`] && this.state.formRefs[i].current!.isValid(false) ? this.props.modelErrors[`AlternateEmails[${i}]`] : 'E-mail skal indeholde en valid e-mail.'} 
                    ref={this.state.formRefs[i]} />
            )}
            {!!this.state.formRefs.length && <p>Indtast ekstra e-mail, som du gerne vil kunne sende til gruppen fra. Du modtager kun beskeder på din primære mail.</p>}
            <a href="/#" className={'button button--action has-icon add-email'.cAppend(this.props.disabled || this.state.disableAdd, 'invalid')} onClick={this.addAlternateEmail}>
                <span className="text">
                    <span className="icon icon--right-spacing"><Icon name="plus" /></span>
                    Tilføj ekstra e-mail
                </span>
            </a>
        </React.Fragment>;
    }

    public getAlternateEmails = () => Object.keys(this.state.alternateEmails).map(key => this.state.alternateEmails[key]);

    public isValid = () => this.state.formRefs.reduce((prev, current) => prev && current.current !== null && current.current.isValid(), true);

    private onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const dynamicState: any = {
            alternateEmails: {
                ...this.state.alternateEmails,
                [event.target.name]: event.target.value
            }
        };

        this.setState(dynamicState, () => {
            this.setState({ disableAdd: !this.isValidWithValues() });
            this.props.onChange();
        });
    }

    private isValidWithValues = () => this.state.formRefs.reduce((prev, current) => prev && current.current !== null && current.current.isValid(false), true);

    private setAlternateEmails = (alternateEmails: string[]) => {
        const setAlternateEmails: { [key: string]: string } = {};

        alternateEmails.forEach((ae, i) => setAlternateEmails[`email-${i}`] = ae);

        this.setState({ alternateEmails: setAlternateEmails, formRefs: alternateEmails.map(() => React.createRef<FormText>())});
    }

    private addAlternateEmail = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        e.preventDefault();

        if (this.props.disabled || this.state.disableAdd) {
            return;
        }

        const newRef = React.createRef<FormText>();

        this.setState({
            alternateEmails: {
                ...this.state.alternateEmails,
                [`email-${this.state.formRefs.length}`]: ''
            },
            formRefs: [...this.state.formRefs, newRef],
            disableAdd: true
        }, () => newRef.current && newRef.current.focus());
    };
}

export default AlternateEmails;